<template>
<base-layout>
  <div style="height: 100%; overflow: auto;">
        <div class="add-project-section" style="border-bottom: 1px solid #c4c3c8">
            <h3 class="folder-header-heading" v-if="isUpdateProject == true">Update Project</h3>
            <h3 class="folder-header-heading" v-else>Add Project</h3>
        </div>
        <div class="add-project-subsection">
            <h4 class="folder-Subheader-heading">Project Information</h4>
            <p>Please enter the information needed for creating a project. It will be added to your ‘projects’ list.</p>
            <div class="row">
                <div class="col-md-12 pL0">
                    <div class="col-md-12" style="padding-top: 20px;">
                        <div class="col-md-12" style="padding:0px 0px">
                            <div class="form-group">
                                <p class="headline">Project Title<span style="color:red">*</span></p>
                                <ob-input type="text" :class="{ 'ob-vuelidate_input-error': $v.completeProjectDetails.ProjectTitle.$error }" placeholder="Enter Project Title" v-model.trim="completeProjectDetails.ProjectTitle" style="border-radius: 4px !important;"></ob-input>
                                <span class="ob-vuelidate_error-msg" v-if="$v.completeProjectDetails.ProjectTitle.$dirty && !$v.completeProjectDetails.ProjectTitle.required">Please enter project title</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 pL0">
                    <div class="col-md-12" style="padding-top: 20px;">
                        <div class="col-md-12" style="padding:0px 0px">
                            <div class="form-group">
                                <p class="headline">Project Description<span style="color:red">*</span></p>
                                <div :class="{ 'ob-vuelidate_input-error': $v.completeProjectDetails.projectDescription.$error }">
                                    <tinymce :height="230+'px'" className="body_content" :inputData="JobDescription" :toolbar-required="true" :auto-resize="false" @textareaInput="jobDescriptionInput"></tinymce>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.completeProjectDetails.projectDescription.$dirty && !$v.completeProjectDetails.projectDescription.required">Please enter project description</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 pL0">
                    <div class="col-md-12" style="padding-top: 20px;">
                        <div class="col-md-12" style="padding:0px 0px">
                            <div class="form-group">
                                <p class="headline">Key skills<span style="color:red">*</span></p>
                                <ob-select2 :initialData="keySkillsArr" :options="keySkillsOpt" :multiple="true" v-model.trim="completeProjectDetails.KeySkills" :class="{ 'ob-vuelidate_input-error': $v.completeProjectDetails.KeySkills.$error }"></ob-select2>
                                <span class="ob-vuelidate_error-msg" v-if="$v.completeProjectDetails.KeySkills.$dirty && !$v.completeProjectDetails.KeySkills.required">Please enter key skills</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 pL0">
                    <div class="col-md-12" style="padding-top: 20px;">
                        <div class="col-md-10" style="padding:0px 0px">
                            <div class="form-group">
                                <p class="headline">Additional Activities/Tasks</p>
                                <ob-auto-complete placeholder="Enter activities/tasks" :suggestions="suggestions" v-model="activityTask" > </ob-auto-complete>
                                <p v-if="checkTaskLength" style="padding:5px;font-weight:600">No results found !</p>
                                <i aria-hidden="true" v-if="tasksLoading && !checkTaskLength" class="fa fa-spinner loading-tasks"></i>
                            </div>
                        </div>
                        <div class="col-md-2" style="padding:20px 10px 0px 20px">
                            <ob-button @click="addActivites">Add Task</ob-button>
                        </div>
                        <div class="col-md-12">
                            <div class="reqact-tasks">
                                <div class="checkbox" v-for="(data,index) in arrActTask" v-bind:key="index" v-if="data.isChecked == true">
                                    <label>
                                        <input type="checkbox" checked value="index" :key="index" v-model="data.isChecked" @click="removeTaskData(data,index)">
                                        <span></span>{{data.inputValue}}
                                    </label>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>




                    <!-- need -->
                <div class="col-md-12 pL0">
                    <div class="col-md-12" style="padding-top: 20px;">
                        <div class="col-md-6 p0">
                            <div class="col-md-6" style="padding-left:0px">
                                <div class="form-group">
                                    <label class="headline">Project Begin Date<span style="color:red">*</span></label>
                                    <ob-date-time-picker id="startdate" :inputvalue="completeProjectDetails.StartDate" placeholder="Select Date" :class="{ 'ob-vuelidate_input-error': $v.completeProjectDetails.StartDate.$error }" :options="datePickerOptions" @updated="(v) => this.completeProjectDetails.StartDate = v" :dpchange="onFromDateChange" ref="projectStartDateRef"></ob-date-time-picker>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.completeProjectDetails.StartDate.$dirty && !$v.completeProjectDetails.StartDate.required">Please select project begin date</span>
                                </div>

                            </div>
                            <div class="col-md-6" style="padding-left:0px">
                                <div class="form-group">
                                    <label class="headline">Project End Date<span style="color:red">*</span></label>
                                    <ob-date-time-picker id="EndDate" :inputvalue="completeProjectDetails.EndDate" placeholder="Select Date" :options="datePickerOptions" :class="{ 'ob-vuelidate_input-error': $v.completeProjectDetails.EndDate.$error }" @updated="(v) => this.completeProjectDetails.EndDate = v" :dpchange="onEndDateChange" ref="projectEndDateRef"></ob-date-time-picker>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.completeProjectDetails.EndDate.$dirty && !$v.completeProjectDetails.EndDate.required">Please select project end date</span>
                                </div>

                            </div>
                        </div>
                        <div class="col-md-6" style="padding:0x 0px 0px 10px">
                            <div class="col-md-6" style="padding-left:0px">
                                <div class="form-group">
                                    <label class="headline">Duration (Estimate in months)<span style="color:red">*</span></label>
                                    <ob-input v-number-only="true" name="duration" placeholder="End Duration" v-model.trim="completeProjectDetails.Duration" :maxLength="3" v-bind:class="{ 'ob-vuelidate_input-error': $v.completeProjectDetails.Duration.$error }" @input.native="DurationFiledData"> </ob-input>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.completeProjectDetails.Duration.$dirty && !$v.completeProjectDetails.Duration.required">Please enter duration</span>
                                    <span class="ob-vuelidate_error-msg" v-if="durationMaxLength">Duration should not exceed 200 months</span>

                                </div>

                            </div>
                            <div class="col-md-6" style="padding-left:0px">
                                <div class="form-group">
                                    <label class="headline">End Client Organization Name <span v-tooltip="'The organization where the consultant will work.'"><i class="fa fa-info-circle"></i></span><span style="color:red">*</span></label>
                                    <ob-input v-model.trim="completeProjectDetails.EndClientOrganizationName" placeholder="End Client" :class="{ 'ob-vuelidate_input-error': $v.completeProjectDetails.EndClientOrganizationName.$error }"></ob-input>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.completeProjectDetails.EndClientOrganizationName.$dirty && !$v.completeProjectDetails.EndClientOrganizationName.required">Please enter End Client Organization Name</span>
                                    <!-- <span class="ob-vuelidate_error-msg" v-if="$v.completeProjectDetails.EndClientOrganizationName.$dirty && !$v.completeProjectDetails.EndClientOrganizationName.minLength">Please enter minimum 5 characters</span> -->
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                    <!-- end -->

                <div class="col-md-12 pL0" style="padding-top: 20px;">
                    <div class="col-md-12 pL0" v-for="(worknew,index) in completeProjectDetails.workLocation" :key="index">
                        <div class="col-md-12 section-project-padding pB0">
                            <div class="row m0">
                                <div class="col-md-9 p0">
                                    <h2 class="workaddress-header">Work Location {{index+1}} <span v-if="index == 0">(Actual work address)</span></h2></div>
                                <div class="col-md-3" style="padding: 15px 0px 0px 0px;"><a href="javascript:;" v-if="index > 0" style="text-decoration:underline" class="remove-worklocation" @click="removeWorkAddress(completeProjectDetails.workLocation,index)">Remove work location</a></div>
                            </div>
                            <div class="col-md-3 pL0">
                                <div class="form-group">
                                    <label class="headline"> Address 1 <span style="color:red">*</span></label>
                                    <ob-input placeholder="Enter Address 1" :disabled="worknew.disabledWF" v-model.trim="worknew.Address1" v-bind:class="{ 'ob-vuelidate_input-error': $v.completeProjectDetails.workLocation.$each[index].Address1.$error }"></ob-input>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.completeProjectDetails.workLocation.$each[index].Address1.$dirty && !$v.completeProjectDetails.workLocation.$each[index].Address1.required">Please enter Address 1 </span>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <label class="headline"> Address 2 </label>
                                <ob-input placeholder="Enter Address 2" :disabled="worknew.disabledWF" v-model.trim="worknew.Address2"> </ob-input>
                                <!--<span class="ob-vuelidate_error-msg" v-if="$v.completeProjectDetails.workLocation.$each[index].Address2.$dirty && !$v.completeProjectDetails.workLocation.$each[index].Address2.required">Please enter Address 2 </span>-->
                            </div>
                            <div class="col-md-3 ">
                                <div class="form-group">
                                    <label class="headline"> City, State <span style="color:red">*</span></label>
                                    <location-search :vmodelData.sync="worknew.Location" v-bind:class="{ 'ob-vuelidate_input-error': $v.completeProjectDetails.workLocation.$each[index].Location.$error }" @input="getZipCode(worknew)"></location-search>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.completeProjectDetails.workLocation.$each[index].Location.$dirty && !$v.completeProjectDetails.workLocation.$each[index].Location.required">Please enter City, State </span>
                                </div>
                            </div>

                            <div class="col-md-3" style="padding:0px 3px;">
                                <div class="form-group">
                                    <label class="headline">Zip code <span style="color:red">*</span></label>
                                    <ob-input placeholder="Zip code" v-model.trim="worknew.Zipcode" :disabled="worknew.disabledWF" :maxLength="5" v-number-only v-bind:class="{ 'ob-vuelidate_input-error': $v.completeProjectDetails.workLocation.$each[index].Zipcode.$error }"></ob-input>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.completeProjectDetails.workLocation.$each[index].Zipcode.$dirty && !$v.completeProjectDetails.workLocation.$each[index].Zipcode.required">Please enter Zip code </span>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!-- <div style="clear:both;"></div> -->
                </div>
                <div class="add-work-new" v-if="completeProjectDetails.workLocation.length < 5"> <a href="javascript:;" style="text-decoration:underline" class="mL0" @click="AddWorkAddress">+ Add new work location</a> </div>

            </div>
             <div class="Add-project-BottomSection">
                    <ob-button type="secondary" @click="cancelAddProject">Cancel</ob-button>
                    <ob-button type="primary" v-if="isUpdateProject == true" width="65px" @click="uploadAddProject">Update</ob-button>
                    <ob-button type="primary" v-else width="65px" @click="uploadAddProject">Add</ob-button>
            </div>

        </div>
  </div>
  </base-layout>
</template>

<script>
    import tinymce from "@/Components/tinymce.vue";
    import { required, requiredIf, maxLength, alpha, email, minValue, minLength}
    from 'vuelidate/lib/validators'
    import c from 'Vue/Core/constants.js'
    import { req, withParams }
    from 'vuelidate/lib/validators/common'

    export default {
        data() {
            return {
                completeProjectDetails: {
                    ProjectTitle: '',
                    projectDescription: '',
                    KeySkills: [],
                    StartDate: '',
                    EndDate: '',
                    Duration: '',
                    EndClientOrganizationName: '',
                    workLocation: [{
                        "Address1": '',
                        "Address2": '',
                        "Location": '',
                        "Zipcode": ''

                    }],
                },
                activityTask: '',
                isUpdateProject: false,
                keySkillsArr: [],
                suggestions: [],
                tasksLoading: false,
                checkTaskLength: false,
                arrActTask: [{
                    isChecked: false,
                    inputValue: ''
                }],
                JobDescription: '',
                durationMaxLength:false,
                // options
                keySkillsOpt: {
                        ajax: {
                            type: 'GET',
                            url: function(params) {
                                return `${c.APIBASEURL}/Job/GetKeySkillByName?name=${params.term}`
                            },
                            delay: 250,
                            data: function(params) {
                                return {
                                    searchWord: params.term //search term
                                };
                            },
                            headers: {
                                'Authorization': `Bearer ${localStorage.getItem('access_token')}`
                            },
                            processResults: function(data, params) {
                                try {
                                    data = JSON.parse(data);
                                } catch(ex) {

                                }
                                let results = []
                                if (data != null) {
                                    data.list.forEach((e) => {
                                        results.push({
                                            id: e.Name,
                                            text: e.Name
                                        })
                                    })
                                }
                                return {
                                    results: results
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 1,
                        escapeMarkup: function(markup) {
                            return markup;
                        },
                        templateResult: function(cities) {
                            if (cities.loading)
                                return cities.text;
                            var markup = '<option value="' + cities.text + '">' + cities.text + '</option>';

                            return markup;
                        },
                        templateSelection: function(cities) {
                            return cities.text
                        },
                        tags: true,
                        tokenSeparators: [','],
                        createTag: function(params) {
                            let lastElem = params.term
                            var count = lastElem.match(/\S+/g).length;
                            if (count <= 3 && count > 0) {
                                var userVal = lastElem.match(/\S+/g);

                                for (var i = 0; i < userVal.length; i++) {

                                    if (userVal[i].length > 15 && userVal[i].length > 0) {
                                        return null
                                    }
                                }
                                return {
                                    id: "##" + params.term,
                                    text: params.term,
                                    newOption: true
                                }
                            } else {
                                return null
                            }

                        },
                        placeholder: 'Add key skills'
                },
                datePickerOptions: {
                        format: 'MM/DD/YYYY',
                        minDate: moment('01/01/1970', 'MM/DD/YYYY').format('MM/DD/YYYY')
                },

            }
        },

        validations() {
                return {
                    completeProjectDetails: {
                        workLocation: {
                            $each: {
                                Address1: {
                                    required
                                },
                                Location: {
                                    required
                                },
                                Zipcode: {
                                    required
                                },
                            }
                        },
                        Duration: {
                            required
                        },
                        StartDate: {
                            required
                        },
                        EndDate: {
                            required
                        },
                        EndClientOrganizationName: {
                            required,
                            //minLength: minLength(5)
                        },
                        ProjectTitle: {
                            required
                        },
                        projectDescription: {
                            required
                        },
                        KeySkills: {
                            required
                        },
                    },
                }
        },

        created(){
                  this.$loading({'loadingText': 'Loading...' })
                this._getUrlparms()

                if (this.urlParamsValues.projectid != undefined) {
                    this.getUpdateProjectDetails()
                    if(this.urlParamsValues.isnewproject == 'true'){
                        this.isUpdateProject = false
                    }else{
                     this.isUpdateProject = true
                    }
                    this.$loading({}).close()

                }
                this.$loading({}).close()

                if (this.$route.query.isPasteFromClipboard == true) {
                    this.updateCompleteProjectValuesFromStore();
                }
        },

        watch: {
                activityTask() {
                   if(this.activityTask == " ") {
                       this.activityTask = ""
                       return false
                   }

                        if (this.activityTask.length > 0) {
                            setTimeout(() => {
                                this.getSocSearchTask()
                                    // this.updateSocInformation()
                            }, 600)
                        } else {
                            this.suggestions = []
                        }

                },

        },

        components: {
            "tinymce": tinymce,
        },

        methods :{
            removeWorkAddress(arr,index){
                            arr.splice(index, 1)
            },
            getSocSearchTask() {
                        if (this.activityTask.length > 0) {
                            this.checkTaskLength = false
                            this.tasksLoading = true
                            let searchText = this.activityTask
                            var socCode = ''

                            this.suggestions = []
                            ajax.get(`/Soc/GetSocTaskBySearchWord?searchWord=${searchText}&socCode=${socCode}`, {}, (res) => {
                                if (res.data.length > 0) {
                                    this.checkTaskLength = false
                                    let resData = res.data
                                    setTimeout(() => {
                                        this.suggestions = []
                                        resData.forEach((ele) => {
                                            this.suggestions.unshift(ele)
                                        })
                                        this.tasksLoading = false
                                    }, 1000)
                                } else {
                                    this.checkTaskLength = true
                                    this.suggestions = []
                                }
                            })
                        } else {
                            this.suggestions = []
                        }
            },

            jobDescriptionInput(v) {
                        this.completeProjectDetails.projectDescription = v
            },

            addActivites() {
                        if (this.activityTask != '') {
                            var activitiesTask = this.activityTask
                            let obj = {};
                            obj.isChecked = true;
                            obj.inputValue = activitiesTask;
                            this.arrActTask.unshift(obj);
                            this.activityTask = ''
                            this.suggestions = []
                        } else {
                            this.$message({
                                type: 'error',
                                message: 'Activites/Task field is empty'
                            })
                        }
            },

            onEndDateChange() {
                        var date = this.$refs.projectStartDateRef.value
                        if(date != "")
                            this.$refs.projectEndDateRef.data.minDate(date)
                        this.durationChangedValue()
            },

            durationChangedValue() {
                    setTimeout(() => {
                        if (this.completeProjectDetails.StartDate != '' && this.completeProjectDetails.EndDate) {
                            var a = moment(this.completeProjectDetails.StartDate);
                            var b = moment(this.completeProjectDetails.EndDate);

                            let months = b.diff(a, 'months')
                            if(months == 0) {
                                months = 1
                            }
                            if(months > 200)
                            {
                                this.durationMaxLength = true
                            }
                            else{
                                this.durationMaxLength = false
                                    b.add(months, 'months')
                                this.completeProjectDetails.Duration = `${months}`
                            }
                        } else {
                            this.completeProjectDetails.Duration = 0
                        }
                    }, 100)
            },

            AddWorkAddress() {
                let obj = {
                            "Address1": "",
                            "Address2": '',
                            "Location": '',
                            "Zipcode": ''
                }
                this.completeProjectDetails.workLocation.push(obj)
            },

            onFromDateChange(e) {
                setTimeout(() => {
                    var date = this.$refs.projectEndDateRef.value
                    if(date != ""){
                        var startDate = moment(String(this.$refs.projectStartDateRef.value)).format("YYYY/MM/DD")
                        var endDate = moment(String(this.$refs.projectEndDateRef.value)).format("YYYY/MM/DD")

                        if(startDate > endDate)
                            this.$refs.projectEndDateRef.data.minDate(e.date)
                    }
                }, 100)
                this.durationChangedValue()
            },

            getZipCode(l) {
                setTimeout(() => {
                    if (l.Location != '' && l.Location != null) {
                        ajax.get(`/Account/GetZipCode?location=${l.Location}`, {}, (res) => {
                            l.Zipcode = res.data.ZipCodeModel.ZipCode
                        })
                    } else
                        l.Zipcode = ''

                }, 100)
            },

            cancelAddProject() {
                            this.$router.push({
                                path: 'employee/projects'
                            })
            },
            uploadAddProject() {
                this.$v.completeProjectDetails.$touch()
                if (this.$v.completeProjectDetails.$invalid == false && this.durationMaxLength == false) {
                     if (this.urlParamsValues && this.urlParamsValues.projectid != undefined) {
                            var updateProjId = this.urlParamsValues.projectid
                        } else {
                            var updateProjId = ''
                        }

                     var workingLocations = []
                        this.completeProjectDetails.workLocation.forEach((s) => {
                            var str = s.Location
                            var strArray = str.split(',')
                            var cityLocation = strArray[0]
                            var stateLocation = strArray[1]
                            var CompleteAddress = {
                                "Address1": s.Address1,
                                "Address2": s.Address2,
                                "City": cityLocation,
                                "State": stateLocation,
                                "Zip": s.Zipcode
                            }
                            workingLocations.push(CompleteAddress)
                        })
                       var requiredactivities = []
                        if(this.arrActTask.length > 0) {
                            this.arrActTask.forEach((val) => {
                                if(val.isChecked == true) {
                                    var resultVal =  val.inputValue
                                    requiredactivities.push(resultVal)
                                }
                            })
                        }
                     this.$loading({
                            'loadingText': 'Loading...'
                        })

                            var str1 = this.completeProjectDetails.workLocation[0].Location
                            var strArray = str1.split(',')
                            var cityLocation = strArray[0]
                            var stateLocation = strArray[1]
                            var params = {
                                "JobName": this.completeProjectDetails.ProjectTitle,
                                "Description": this.completeProjectDetails.projectDescription,
                                "KeySkills": this.completeProjectDetails.KeySkills,
                                "RequiredActivities": requiredactivities,
                                "Id": updateProjId,
                                "ProjectStartDate": this.completeProjectDetails.StartDate,
                                "ProjectEndDate": this.completeProjectDetails.EndDate,
                                "Duration": this.completeProjectDetails.Duration,
                                "EndClientOrganizationName": this.completeProjectDetails.EndClientOrganizationName,
                                "WorkLocations": workingLocations,
                                "IsEmployeeAddingProject": true,
                                "IsNewProject" : !this.isUpdateProject
                            }
                            console.log("params",params)
                              ajax.post(`/OnBoard/AddProject?consultantId=${loggedInUserObj.consultantId}&employeeOrgId=${loggedInUserObj.orgId}`, params, (res) => {
                                if (res.data.State == true) {
                                    this.$loading({}).close()
                                    this.$message({
                                            type: 'success',
                                            message: 'Project Saved successfully'
                                        })
                                        this.$router.push({
                                            path: '/employee/projects'
                                        })
                                } else {
                                    this.$loading({}).close()
                                    this.$message({
                                        type: 'error',
                                        message: res.data.Message
                                    })

                                }
                            });


                }
            },

            removeTaskData(data, index) {
                        this.arrActTask.splice(index, 1);
            },

            DurationFiledData(d) {
                if (d != '' && this.completeProjectDetails.StartDate != '') {
                    let monthscount = parseInt(this.completeProjectDetails.Duration)
                    if(monthscount > 200)
                    {
                        this.durationMaxLength = true
                    }
                    else
                    {
                        this.durationMaxLength = false
                        var endDatedata = this.completeProjectDetails.StartDate
                        var currentDate = moment(endDatedata);
                        var futureMonth = moment(currentDate).add(monthscount, 'M');
                        var futureMonthEnd = moment(futureMonth).endOf('month');
                        this.completeProjectDetails.EndDate = futureMonth.format('MM/DD/YYYY')
                    }

                } else {
                    this.completeProjectDetails.EndDate = this.$refs.projectStartDate.cinputvalue
                }
            },

            updateCompleteProjectValuesFromStore() {
                        this.completeProjectDetails.KeySkills = this.$store.getters.getRequirementsField('KeySkills')
                        // this.completeProjectDetails.EducationQual = this.$store.getters.getRequirementsField('EducationQual')
                        this.completeProjectDetails.projectDescription = this.$store.getters.getRequirementsField('JobDescription')
                        this.JobDescription = this.$store.getters.getRequirementsField('JobDescription')

                        if (this.completeProjectDetails.KeySkills != null) {
                            this.completeProjectDetails.KeySkills.forEach((k) => {
                                let obj = {
                                    id: k,
                                    text: k
                                }
                                this.keySkillsArr.push(obj)
                            })
                        }
            },

            _getUrlparms() {
                        var urlParams;
                        (window.onpopstate = function() {
                            var match,
                                pl = /\+/g, // Regex for replacing addition symbol with a space
                                search = /([^&=]+)=?([^&]*)/g,
                                decode = function(s) {
                                    return decodeURIComponent(s.replace(pl, " "));
                                },
                                query = window.location.search.substring(1);

                            urlParams = {};
                            while (match = search.exec(query))
                                urlParams[decode(match[1].toString().toLowerCase())] = decode(match[2]);
                        })();
                        this.urlParamsValues = urlParams;
            },

            getUpdateProjectDetails() {
                        let val = this.urlParamsValues.projectid
                        let constIdVal
                        if(this.urlParamsValues.consultantid != null & this.urlParamsValues.consultantid != '' && this.urlParamsValues.consultantid != undefined)
                        {
                                 constIdVal =  this.urlParamsValues.consultantid
                        }else{
                            constIdVal= ''
                        }
                        var isFromClipBoard = "No"
                        if(this.urlParamsValues.isnewproject == 'true'){
                            isFromClipBoard = "yes"
                        }
                        this.$loading({'loadingText': 'Loading...'})
                        ajax.get(`Projects/UpdateProjectDetails?projectId=${val}&isFromClipBoard=${isFromClipBoard}&consultantId=${constIdVal}`, {}, (res) => {

                            if (res.status == 200) {
                                this.$loading({}).close()
                                this.updateProjectDetailsObj = res.data
                                this.updateProjectInformation()

                            }
                        })
            },

             updateProjectInformation() {
                this.$loading({'loadingText': 'Loading...'})
                        // this.updateProjectDetailsObj
                        this.completeProjectDetails.ProjectTitle = this.updateProjectDetailsObj.Name
                        console.log(this.updateProjectDetailsObj.Description != null && this.updateProjectDetailsObj.Description != '',"tested" )
                        this.JobDescription = this.updateProjectDetailsObj.Description != null && this.updateProjectDetailsObj.Description != '' ? this.updateProjectDetailsObj.Description : ''
                        if (this.updateProjectDetailsObj.KeyTags != null) {
                            this.updateProjectDetailsObj.KeyTags.forEach((k) => {
                                let obj = {
                                    id: k,
                                    text: k
                                }
                                this.keySkillsArr.push(obj)

                            })
                        }
                        //For Updating key Skills
                        if (this.updateProjectDetailsObj && (this.updateProjectDetailsObj.RequiredActivities != null && this.updateProjectDetailsObj.RequiredActivities != '')) {
                            this.updateProjectDetailsObj.RequiredActivities.forEach((val , index) => {

                                 if(index == 0){
                             this.arrActTask[0].inputValue = val
                             this.arrActTask[0].isChecked = true
                                }
                                else{
                                            let obj = {};
                                            obj.isChecked = true;
                                            obj.inputValue = val;
                                            this.arrActTask.unshift(obj);
                                }


                            })
                            this.activityTask = ''
                            this.suggestions = []
                        }

                         if(this.updateProjectDetailsObj.ProjectStartDate == '01/01/0001' || this.updateProjectDetailsObj.ProjectStartDate == '1/1/0001'){
                             this.$refs.projectStartDateRef.value = ''
                         }
                         else{
                          this.$refs.projectStartDateRef.value = moment.utc(this.updateProjectDetailsObj.ProjectStartDate).format('L')
                         }
                         if(this.updateProjectDetailsObj.ProjectEndDate == '01/01/0001' || this.updateProjectDetailsObj.ProjectEndDate == '1/1/0001'){
                             this.$refs.projectEndDateRef.value = ''
                         }
                         else{
                          this.$refs.projectEndDateRef.value = moment.utc(this.updateProjectDetailsObj.ProjectEndDate).format('L')
                         }


                        this.completeProjectDetails.Duration = this.updateProjectDetailsObj.Duration
                        this.completeProjectDetails.EndClientOrganizationName = this.updateProjectDetailsObj.EndClientOrganizationName

                        if(this.updateProjectDetailsObj && this.updateProjectDetailsObj.WorkLocations && this.updateProjectDetailsObj.WorkLocations.length > 0) {
                            this.updateProjectDetailsObj.WorkLocations.forEach((tempObj, index) => {
                                if(tempObj != null){
                                var wrkaddr2
                                if(tempObj.Address2 == null || tempObj.Address2 ==  undefined ){
                                wrkaddr2 = ''
                                }
                                else{
                                        wrkaddr2 = tempObj.Address2.trim()
                                }
                                //var res = tempObj.split(',')
                                if (index == 0) {
                                    this.completeProjectDetails.workLocation[0].Address1 = tempObj.Address1 != null && tempObj.Address1 != '' ? tempObj.Address1.trim() : ''
                                    this.completeProjectDetails.workLocation[0].Address2 = wrkaddr2
                                    this.completeProjectDetails.workLocation[0].Location = tempObj.City != null && tempObj.City != '' && tempObj.State != null && tempObj.State != '' ? tempObj.City.trim() + ', ' + tempObj.State.trim() : (tempObj.AddressSummary != null && tempObj.AddressSummary != '' ? tempObj.AddressSummary : '')
                                    this.completeProjectDetails.workLocation[0].Zipcode = tempObj.Zip != null && tempObj.Zip != '' ? tempObj.Zip : ''

                                } else {
                                    let obj = {
                                        "Address1": tempObj.Address1 != null && tempObj.Address1 != '' ? tempObj.Address1.trim() : '',
                                        "Address2": wrkaddr2,
                                        "Location": tempObj.City != null && tempObj.City != '' && tempObj.State != null && tempObj.State != '' ? tempObj.City.trim() + ', ' + tempObj.State.trim() : (tempObj.AddressSummary != null && tempObj.AddressSummary != '' ? tempObj.AddressSummary : ''),
                                        "Zipcode": tempObj.Zip != null && tempObj.Zip != '' ? tempObj.Zip : ''
                                    }
                                    this.completeProjectDetails.workLocation.push(obj)
                                }
                                }
                                else{

                                    let obj = {
                                        "Address1": '',
                                        "Address2": '',
                                        "Location": '',
                                        "Zipcode": ''
                                    }
                                    this.completeProjectDetails.workLocation.push(obj)

                                }

                            })
                        }

                        this.$loading({}).close()

                    },
        },
    }

</script>


<style lang="scss" scoped>
    .add-project-section {
        padding: 20px;
        background: #fff;
    }

    .add-project-subsection {
        padding: 20px 40px 20px 40px;
        background: #fff;
        .project-subsection {
            padding: 20px 0px 20px 0px;
        }
    }

    .folder-header-heading {
        color: #143361;
        font-weight: 700;
        font-size: 17px;
    }

    .folder-Subheader-heading {
        color: #143361;
        font-weight: 600;
        font-size: 16px;
    }

    .headline {
        font-size: 13px;
        font-weight: 600
    }

    .ob-onboard__ProjectInfo-anchor {
        float: right;
        font-weight: 600;
        a {
            color: #4A90E2;
            font-size: 11px;
            text-decoration: underline
        }
    }

    .headline-message {
        font-size: 15px;
        font-weight: 650;
        color: #0000009e;
        overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
    white-space: nowrap
    }

    .workaddress-header {
        font-size: 15px;
        font-weight: 650;
        color: #143361;
    }

    .add-work-new {
        float: right;
        padding-right: 50px;
        padding-bottom: 15px;
        a {
            color: #5d91e2;
            font-size: 13px;
            font-weight: 600;
            margin-bottom: 15px;
            margin-top: 0;
            margin-left: 15px;
        }
    }

    .remove-worklocation {
        float: right;
        color: #F31D1D;
        font-size: 13px;
        font-weight: 600;
        margin-top: 5px;
    }

    .Add-project-BottomSection {
        border-top: 1px solid #c4c3c8;
        padding: 25px 40px 20px 600px;
        background-color: #fff
    }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/ESSProjects/AddNewProject.vue